// config.js

export const appName = "ptw";

// Define your global variables
export const restApiUrl = "https://ptwapi.vistaarintuitivesolution.com";
export const authServer = "https://authserver.vistaarintuitivesolution.com";
export const comatHome = authServer + "/welcome";
export const appUrl = "https://ptw.vistaarintuitivesolution.com";

// export const comatHome = "http://127.0.0.1:80/welcome";
// export const restApiUrl = "http://127.0.0.1:8086";
// export const authServer = "http://meet05:9000";
// export const appUrl = "http://127.0.0.1:3000/" + appName;

// 'Accept': 'application/json',
export const headers = () => {
  const token = sessionStorage.getItem("id_token");
  const headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${token}`);
  return headers;
};

// Headers for multipart/form-data requests (file uploads)
// Don't set Content-Type - browser will set it automatically with boundary
export const multipartHeaders = () => {
  const token = sessionStorage.getItem("id_token");
  const headers = new Headers();
  headers.set("Authorization", `Bearer ${token}`);
  return headers;
};

export const ptw_can_create_permit = "PTW Can Create Permit";
export const ptw_can_delete_permit = "PTW Can Delete Permit";
export const ptw_can_view_permit = "PTW Can View Permit";

export const ptw_can_review_competent_person =
  "PTW Can Review Competent Person";
export const ptw_can_review_clearance_department =
  "PTW Can Review Clearance Department";

export const ptw_can_approve_hot_work = "PTW Can Approve Hot Work";
export const ptw_can_approve_cold_work = "PTW Can Approve Cold Work";
export const ptw_can_approve_electrical_work =
  "PTW Can Approve Electrical Work";
export const ptw_can_approve_confined_space_entry =
  "PTW Can Approve Confined Space Entry";
export const ptw_can_approve_work_at_height = "PTW Can Approve Work at Height";
export const ptw_can_approve_excavation_work =
  "PTW Can Approve Excavation Work";
export const ptw_can_approve_chemical_handling =
  "PTW Can Approve Chemical Handling";

export const ptw_can_approve_by_safety = "PTW Can Approve By Safety";

export const ptw_can_issue_permit = "PTW Can Issue Permit";

// Operational sub-module roles (post-issuance)
export const ptw_can_record_gas_test = "PTW Can Record Gas Test";
export const ptw_can_manage_contractors = "PTW Can Manage Contractors";
export const ptw_can_approve_contractors = "PTW Can Approve Contractors";
export const ptw_can_conduct_tbt = "PTW Can Conduct Tool Box Talk";
export const ptw_can_perform_shift_handover = "PTW Can Perform Shift Handover";
export const ptw_can_manage_jsa = "PTW Can Manage JSA";
export const ptw_can_manage_isolation = "PTW Can Manage Isolation Records";
export const ptw_can_manage_revalidation = "PTW Can Manage Revalidation";
export const ptw_can_activate_permit = "PTW Can Activate Permit";
export const ptw_can_manage_meeting = "PTW Can Manage Meeting";
export const ptw_can_manage_tbt = "PTW Can Manage TBT";
